




import Vue from 'vue'

export default Vue.extend({
  props: {
    // это позволит использовать входной параметр `value` для других целей
    checked: Boolean
  },
  mounted() {
      if (this.checked) {
          $(this.$el).prop('checked', true)
      }
      var $this = $(this.$el);

      $this.styler({
	      onFormStyled: function () {
		      $this.closest('.oc-light-form-checkbox.jq-checkbox').find('.jq-checkbox__div')
			      .html('<svg class="oc-light-form-checkbox__icon" width="12" height="9" viewBox="0 0 12 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">'
				      + '<use class="oc-light-form-checkbox__icon-vector" xlink:href="#oc-light-form-checkbox-arrow" fill="#F2994A" />'
				      + '</svg>');
	      }
      });

      $(this.$el).on('change', () => {
        this.$emit('change', $(this.$el).prop('checked'))
      })
  },
  watch: {
    checked() {
      $(this.$el).prop('checked', this.checked).trigger('click');
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/components/Checkbox.vue